import React, { FC } from 'react';
import HorizontalLine from 'app/components/HorizontalLine';
import { Skeleton } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

const SkeletonComp: FC = () => {
  const { xs } = useBreakpoint();
  return (
    <div style={{ margin: '50px auto' }}>
      <Skeleton
        active
        paragraph={{ rows: 10, width: ['100%'] }}
        title={{
          style: { height: '40px', width: xs ? '100%' : '40%' },
        }}
      />
      <HorizontalLine />
    </div>
  );
};

export default SkeletonComp;
